import { useProjectLeadHourlyRates } from "@/hooks/use-project-lead-hourly-rates";
import { periodLabel, type DashboardPeriod } from "@/lib/dashboard-period";
import { HourlyRateRankingPanel } from "./HourlyRateRankingPanel";

interface Props {
  period: DashboardPeriod;
  enabled: boolean;
}

export function ProjectLeadHourlyRatePanel({ period, enabled }: Props) {
  const { data = [], isLoading, isError } = useProjectLeadHourlyRates(period, enabled);
  if (!enabled) return null;

  return (
    <HourlyRateRankingPanel
      title="Reell timepris per prosjektleder"
      subtitle={`Reell GEEK ÷ alle førte timer på prosjekter fullført i ${periodLabel(period)}`}
      entityLabel="Prosjektleder"
      dialogDescription={`Kun prosjekter fullført i ${periodLabel(period)} der personen er registrert som prosjektleder. Alle førte timer på prosjektet er med.`}
      rows={data.map((row) => ({ ...row, id: row.leadId, name: row.leadName }))}
      isLoading={isLoading}
      isError={isError}
      errorText="Kunne ikke laste reell timepris per prosjektleder."
      emptyText="Ingen prosjektledere med fullførte prosjekter i perioden."
    />
  );
}
